import { appActions } from './actions/appActions';
import { catalogToOrderActions } from './actions/catalogToOrderActions';
import { deliverableActions } from './actions/deliverableActions';
import { deliverableSheetActions } from './actions/deliverableSheetActions';
import { dialogsActions } from './actions/dialogsActions';
import { documentsActions } from './actions/documentsActions';
import { drawerActions } from './actions/drawerActions';
import { filterActions } from './actions/filterActions';
import { loadingsActions } from './actions/loadingsActions';
import { managementActions } from './actions/managementActions';
import { snackbarActions } from './actions/snackbarActions';
import { helpmenuActions } from './actions/helpmenuActions';
import { purchaseOrderActions } from './actions/purchaseOrderActions';
import { changeBaseLineActions } from './actions/changeBaselineActions';
import { aiActionTypes } from './actions/aiActions';
import appReducer from './reducers/appReducer';
import catalogToOrderReducer from './reducers/catalogToOrderReducer';
import deliverableReducer from './reducers/deliverableReducer';
import { deliverableSheetReducer } from './reducers/deliverableSheetReducer';
import dialogsReducer from './reducers/dialogsReducer';
import documentsReducer from './reducers/documentsReducer';
import drawerReducer from './reducers/drawerReducer';
import filterReducer from './reducers/filterReducer';
import loadingsReducer from './reducers/loadingsReducer';
import managementReducer from './reducers/managementReducer';
import snackbarReducer from './reducers/snackbarReducer';
import helpmenuReducer from './reducers/helpmenuReducer';
import purchaseOrderReducer from './reducers/purchaseOrderReducer';
import changeBaselineReducer from './reducers/changeBaselineReducer';
import aiReducer from './reducers/aiReducer';
import { RootReducer, RootState } from './redux';
import { appState } from './states/appState';
import { catalogToOrderState } from './states/catalogToOrderState';
import { deliverableSheetState } from './states/deliverableSheetState';
import { deliverableState } from './states/deliverableState';
import { dialogsState } from './states/dialogsState';
import { documentsState } from './states/documentsState';
import { drawerState } from './states/drawerState';
import { filterState } from './states/filterState';
import { loadingsState } from './states/loadingsState';
import { managementState } from './states/managementState';
import { snackbarState } from './states/snackbarState';
import { helpmenuState } from './states/helpMenuState';
import { purchaseOrderState } from './states/purchaseOrderState';
import { changeBaselineState } from './states/changeBaselineState';
import { aiState } from './states/aiState';

const combineReducers =
  <S = RootState>(reducers: { [K in keyof S]: RootReducer<S[K]> }): RootReducer<S> =>
  (state, action) =>
    (Object.keys(reducers) as Array<keyof S>).reduce(
      (prevState, key) => ({
        ...prevState,
        [key]: reducers[key](prevState[key], action),
      }),
      state
    );

export const rootState = {
  app: appState,
  deliverable: deliverableState,
  deliverableSheet: deliverableSheetState,
  dialogs: dialogsState,
  drawer: drawerState,
  filter: filterState,
  loadings: loadingsState,
  management: managementState,
  catalogToOrder: catalogToOrderState,
  snackbar: snackbarState,
  documents: documentsState,
  helpMenu: helpmenuState,
  purchaseOrder: purchaseOrderState,
  changeBaseline: changeBaselineState,
  ai: aiState,
};

export const rootActions = {
  app: appActions,
  deliverable: deliverableActions,
  deliverableSheet: deliverableSheetActions,
  dialogs: dialogsActions,
  drawer: drawerActions,
  filter: filterActions,
  loadings: loadingsActions,
  management: managementActions,
  catalogToOrder: catalogToOrderActions,
  snackbar: snackbarActions,
  documents: documentsActions,
  helpMenu: helpmenuActions,
  purchaseOrder: purchaseOrderActions,
  changeBaseline: changeBaseLineActions,
  ai: aiActionTypes,
};

export const rootReducer = () =>
  combineReducers({
    app: appReducer,
    deliverable: deliverableReducer,
    dialogs: dialogsReducer,
    deliverableSheet: deliverableSheetReducer,
    drawer: drawerReducer,
    filter: filterReducer,
    loadings: loadingsReducer,
    management: managementReducer,
    catalogToOrder: catalogToOrderReducer,
    snackbar: snackbarReducer,
    documents: documentsReducer,
    helpMenu: helpmenuReducer,
    purchaseOrder: purchaseOrderReducer,
    changeBaseline: changeBaselineReducer,
    ai: aiReducer,
  });
